<template>          
  <div :class="[current===id ? 'select' : '' , 'chatSwitch']" @click="chatSwitch">
    <a-row style="padding:14px 8px;">
      <a-col :span="2">
        <a-icon type="message" style="color:rgb(215, 215, 215);font-size:16px;padding-top:3px;"></a-icon>
      </a-col>
      <a-col :span="18">
        <p style="color:rgb(225, 225, 225);font-size:16px;padding-left:4px;"> {{ this.name }} </p>
      </a-col>
      <a-col :span="2">
        <a>
        <a-icon type="setting" class="icon" @click.stop="chatSetting"></a-icon>
        </a>
      </a-col>
      <a-col :span="2">
        <a>
          <a-icon type="delete" class="icon" style="padding-left:4px;" @click.stop="chatDelete"></a-icon>
        </a>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'ChatSwitch',
  props: {
    id: String,
    name: String,
    current: String
  },
  data() {
    return {
    }
  },
  methods: {
    chatSwitch() {
      this.$emit('emitChatSwitch',this.id)
    },
    chatSetting() {
      this.$emit('emitChatSetting',this.id)
    },
    chatDelete() {
      this.$emit('emitChatDelete',this.id)
    }
  }
}
</script>

<style scoped>

.icon {
  color:rgb(215, 215, 215);
  font-size:16px;
  padding-top:3px;
}

.icon:hover {
  color:#FFF;
  font-size:16px;
  padding-top:3px;
}

.chatSwitch {
  height:50px;
  margin:10px 5px 10px 5px;
  border-radius: 6px;
  cursor: pointer;
}

.select {
  background: rgba(180, 180, 180, 0.1);
}

.chatSwitch:hover {
  height:50px;
  margin:10px 5px 10px 5px;
  background: rgba(200, 200, 200, 0.2);
  border-radius: 6px;
  cursor: pointer;
}
</style>
